import GoogleMapsLoader from 'google-maps';

GoogleMapsLoader.KEY = "AIzaSyD3_LrMPDly9s0XUq01iwOkrElNv_NNJoA";
GoogleMapsLoader.LIBRARIES = ["places"];
GoogleMapsLoader.load();

export default GoogleMapsLoader;


// WEBPACK FOOTER //
// ./src/tools/GoogleMaps.js